import { enqueueSnackbar } from 'notistack';

import { ListItemText } from '@mui/material';

import { useCopyToClipboard } from 'src/hooks/use-copy-to-clipboard';

type Props = {
  label: string;
  value?: string | number | null;
  capitalize?: boolean;
  // Extra styling for the value, e.g. whiteSpace for multi-line text.
  valueSx?: object;
};

// A label/value pair whose value copies to the clipboard when clicked.
export default function CopyableDetail({ label, value, capitalize, valueSx }: Props) {
  const { copy } = useCopyToClipboard();

  const text = value === null || value === undefined ? '' : String(value);
  const isCopyable = text !== '' && text !== '-';

  const handleCopy = async () => {
    const copied = await copy(text);
    enqueueSnackbar(copied ? `${label} copied` : 'Failed to copy', {
      variant: copied ? 'success' : 'error',
    });
  };

  return (
    <ListItemText
      primary={label}
      secondary={text}
      primaryTypographyProps={{ typography: 'body2' }}
      secondaryTypographyProps={{
        component: 'span',
        color: 'text.disabled',
        textTransform: capitalize ? 'capitalize' : undefined,
        sx: isCopyable
          ? {
              ...valueSx,
              cursor: 'pointer',
              '&:hover': { color: 'text.primary', textDecoration: 'underline' },
            }
          : valueSx,
        ...(isCopyable && { onClick: handleCopy, title: 'Click to copy' }),
      }}
    />
  );
}
